/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import UILink from 'components/UI/Link/Link';
import classnames from 'classnames';
import Tippy from '@tippyjs/react';

import './IconLink.scss';

const cbn = 'ui-icon-link';

const clear = (className: string) => className.split(' ')[0];

function UIIconLink({
  className = null,
  disabled = false,
  icon = null,
  size = 'medium',
  to = null,
  target = null,
  tooltip = null,
  href = null,
  dataCy,
  ...restProps
}: {
  className?: string | null;
  disabled?: boolean;
  icon?: string | null;
  size: string;
  to?: string | null;
  target?: string | null;
  tooltip?:
    | string
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | null;
  href?: string | null;
  dataCy?: string;
}) {
  // This is the only way to give it a proper classname. Luckily this lifecycle
  // hook is called before the node is appended to the DOM. Reference:
  // https://atomiks.github.io/tippyjs/lifecycle-hooks/#onshow
  const onShow = (instance: any) => {
    if (instance.popper && className) {
      instance.popper.classList.add(`${clear(className)}__popper`);
    }
  };

  const renderIcon = () => {
    const iconComponent = (
      <span className={classnames(`${cbn}__icon`, `icon-${icon}`)} />
    );

    if (tooltip) {
      <Tippy animation="shift-toward" arrow content={tooltip} onShow={onShow}>
        {iconComponent}
      </Tippy>;
    }

    return iconComponent;
  };

  return (
    <UILink
      {...restProps}
      dataCy={dataCy}
      target={target}
      href={href}
      to={to}
      disabled={disabled}
      className={classnames(cbn, className, {
        [`${cbn}--size-${size}`]: size,
        [`${cbn}--is-disabled`]: disabled,
      })}
    >
      {renderIcon()}
    </UILink>
  );
}

export default UIIconLink;
